import React from 'react'

// =============================================================================
// Shared Icons for Upload Cards
// =============================================================================

// Close circle icon for removable cards
export const CloseCircleIcon = () => (
  <svg
    width='18'
    height='18'
    viewBox='0 0 1024 1024'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359c-1.2-1.5-1.9-3.3-1.9-5.2 0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z'
      fill='currentColor'
    />
  </svg>
)

// =============================================================================
// Shared Utilities
// =============================================================================

/**
 * Extract file extension from filename
 */
export const getFileExtension = (filename: string): string => {
  const parts = filename.split('.')
  if (parts.length > 1) {
    return parts[parts.length - 1].toLowerCase()
  }
  return 'file'
}

/**
 * Get filename without extension (for display purposes)
 * For directories, returns the name as-is
 */
export const getFileNameWithoutExtension = (
  filename: string,
  isDirectory: boolean = false
): string => {
  if (isDirectory) {
    return filename
  }
  const lastDotIndex = filename.lastIndexOf('.')
  if (lastDotIndex > 0) {
    return filename.slice(0, lastDotIndex)
  }
  return filename
}

// =============================================================================
// Shared Styles
// =============================================================================

export const CARD_STYLES = {
  background: 'rgba(132,111,225,0.1)',
  backgroundError: 'rgba(217,75,54,0.1)',
  borderRadius: '16px',
  shadow:
    '0px 2px 4px 0px rgba(0,0,0,0.02), 0px 1px 6px -1px rgba(0,0,0,0.02), 0px 1px 2px 0px rgba(0,0,0,0.03)',
  textPrimary: 'rgba(0,0,0,0.88)',
  textSecondary: 'rgba(0,0,0,0.45)',
  textError: '#d94b36',
  iconColor: '#8E8E8E',
  progressBarBg: 'rgba(0,0,0,0.06)',
  progressBarFill: '#846FE1'
} as const

// Card sizes
export const CARD_SIZES = {
  input: { width: 236, height: 64 }, // For chat input (upload during input)
  message: { width: 192, height: 64 } // For message display (historical)
} as const
